/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.ReturnCenter - Api
 * NWG.Commerce.ReturnCenter - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.ReturnCenter - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
export const B2CNotificationStatus = {
    Pending: 0,
    Sent: 1,
    PublishFailed: 2,
    Succeeded: 3,
    Failed: 4
};
export const BatchPackageState = {
    NotStarted: 0,
    SlipCreated: 1,
    Handled: 2,
    Missing: 3,
    Credited: 4
};
export const BatchReturnProcessingStatus = {
    Received: 0,
    Processed: 1,
    Failed: 2
};
export const BatchReturnStatusType = {
    Open: 0,
    Closed: 10,
    Sent: 20,
    PartiallyReceived: 25,
    Received: 30,
    PartiallyProcessed: 40,
    Completed: 50,
    Incoming: 99
};
export const BuyOutDecision = {
    NoAction: 0,
    Buy: 1
};
export const ElasticResourceType = {
    NWG: 0,
    Scene7: 1,
    External: 2
};
export const ErpEnabledPaymentMethodType = {
    Invoice: 0,
    InvoicePrepay: 1,
    CreditCard: 2
};
export const ErpSource = {
    M3Prod: 0,
    EnterpriseProd: 1,
    M3Dev: 2,
    EnterpriseDev: 3
};
export const ImageExtension = {
    Psd: 0,
    Svg: 1,
    Png: 2,
    Jpg: 3,
    Webp: 4,
    Jpeg: 5
};
export const IntercompanyPreviewKind = {
    Credit: 0,
    BuyOut: 1
};
export const ReasonCodeVisibility = {
    Internal: 0,
    Public: 1
};
export const ReturnAdditionalCostSourceType = {
    PublicBookedFreight: 1
};
export const ReturnB2CStatus = {
    None: 0,
    Queued: 1,
    Processed: 2,
    Failed: 3,
    PublishFailed: 4,
    ManuallyHandled: 5
};
export const ReturnItemRowStatus = {
    Pending: 0,
    Approved: 1
};
export const ReturnKind = {
    Customer: 0,
    Intercompany: 1
};
export const ReturnLogAction = {
    None: 0,
    StatusChanged: 1,
    InternalComment: 2,
    ExternalComment: 3,
    ItemsAdded: 4,
    ItemsRemoved: 5,
    ItemsModified: 6,
    CreditCreated: 7,
    CreditFailed: 8,
    B2CQueued: 9,
    B2CPublishFailed: 10,
    B2CResponse: 11,
    B2CHandled: 12
};
export const ReturnLogCreatorType = {
    None: 0,
    System: 1,
    User: 2,
    Partner: 3,
    Customer: 4
};
export const ReturnOrderLineType = {
    Normal: 0,
    InvoiceCharge: 1,
    BuyOut: 2,
    MisPick: 3
};
export const ReturnStatusType = {
    Created: 0,
    ItemsSelected: 2,
    IncomingPackage: 5,
    Received: 10,
    InProgress: 20,
    OnHold: 30,
    CreditError: 35,
    BatchHandled: 37,
    Processing: 38,
    CreditedBatchPending: 39,
    Completed: 40,
    Cancelled: 100,
    Draft: -10
};
export const ReturnSummaryMode = {
    Hidden: 0,
    Optional: 1,
    Required: 2
};
/**
 * B2CQueueApi - axios parameter creator
 */
export const B2CQueueApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        b2CQueueGetConfig: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/b2c-queue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {B2CQueueConfigDto} [b2CQueueConfigDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        b2CQueueSaveConfigPUT: (b2CQueueConfigDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/b2c-queue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(b2CQueueConfigDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * B2CQueueApi - functional programming interface
 */
export const B2CQueueApiFp = function (configuration) {
    const localVarAxiosParamCreator = B2CQueueApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        b2CQueueGetConfig(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.b2CQueueGetConfig(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['B2CQueueApi.b2CQueueGetConfig']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {B2CQueueConfigDto} [b2CQueueConfigDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        b2CQueueSaveConfigPUT(b2CQueueConfigDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.b2CQueueSaveConfigPUT(b2CQueueConfigDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['B2CQueueApi.b2CQueueSaveConfigPUT']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * B2CQueueApi - factory interface
 */
export const B2CQueueApiFactory = function (configuration, basePath, axios) {
    const localVarFp = B2CQueueApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        b2CQueueGetConfig(options) {
            return localVarFp.b2CQueueGetConfig(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {B2CQueueApiB2CQueueSaveConfigPUTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        b2CQueueSaveConfigPUT(requestParameters = {}, options) {
            return localVarFp.b2CQueueSaveConfigPUT(requestParameters.b2CQueueConfigDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * B2CQueueApi - object-oriented interface
 */
export class B2CQueueApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    b2CQueueGetConfig(options) {
        return B2CQueueApiFp(this.configuration).b2CQueueGetConfig(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {B2CQueueApiB2CQueueSaveConfigPUTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    b2CQueueSaveConfigPUT(requestParameters = {}, options) {
        return B2CQueueApiFp(this.configuration).b2CQueueSaveConfigPUT(requestParameters.b2CQueueConfigDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BatchReturnApi - axios parameter creator
 */
export const BatchReturnApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnCloseRemainingAsMissingPOST: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('batchReturnCloseRemainingAsMissingPOST', 'id', id);
            const localVarPath = `/api/return/batch/{id}/close-remaining`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnCompleteBatchPOST: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('batchReturnCompleteBatchPOST', 'id', id);
            const localVarPath = `/api/return/batch/{id}/complete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateBatchReturnRequest} [createBatchReturnRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnCreateBatchReturnPOST: (createBatchReturnRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/return/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createBatchReturnRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} sourceReturnId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnCreateReturnSlipForPackagePOST: (id, sourceReturnId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('batchReturnCreateReturnSlipForPackagePOST', 'id', id);
            // verify required parameter 'sourceReturnId' is not null or undefined
            assertParamExists('batchReturnCreateReturnSlipForPackagePOST', 'sourceReturnId', sourceReturnId);
            const localVarPath = `/api/return/batch/{id}/packages/{sourceReturnId}/returnslip`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"sourceReturnId"}}`, encodeURIComponent(String(sourceReturnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {CreditBatchSlipsRequest} [creditBatchSlipsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnCreditReturnSlipsPOST: (id, creditBatchSlipsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('batchReturnCreditReturnSlipsPOST', 'id', id);
            const localVarPath = `/api/return/batch/{id}/credit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(creditBatchSlipsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnGetBatchDestinations: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/return/batch/destinations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnGetBatchReturnById: (id, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('batchReturnGetBatchReturnById', 'id', id);
            const localVarPath = `/api/return/batch/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnGetBatchReturnStatistics: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/return/batch/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {BatchReturnStatusType} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnGetBatchReturns: (status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/return/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnGetProcessingSummary: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('batchReturnGetProcessingSummary', 'id', id);
            const localVarPath = `/api/return/batch/{id}/processing`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} sourceReturnId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnMarkPackageMissingPOST: (id, sourceReturnId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('batchReturnMarkPackageMissingPOST', 'id', id);
            // verify required parameter 'sourceReturnId' is not null or undefined
            assertParamExists('batchReturnMarkPackageMissingPOST', 'sourceReturnId', sourceReturnId);
            const localVarPath = `/api/return/batch/{id}/packages/{sourceReturnId}/missing`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"sourceReturnId"}}`, encodeURIComponent(String(sourceReturnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {MoveBatchRowsRequest} [moveBatchRowsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnMoveRowsToBatchPOST: (id, moveBatchRowsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('batchReturnMoveRowsToBatchPOST', 'id', id);
            const localVarPath = `/api/return/batch/{id}/move-rows`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(moveBatchRowsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {ProcessBatchReturnRequest} [processBatchReturnRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnProcessReturnsPOST: (id, processBatchReturnRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('batchReturnProcessReturnsPOST', 'id', id);
            const localVarPath = `/api/return/batch/{id}/processing`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(processBatchReturnRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnReceiveBatchReturnPOST: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('batchReturnReceiveBatchReturnPOST', 'id', id);
            const localVarPath = `/api/return/batch/{id}/receive`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {ReopenBatchReturnRequest} [reopenBatchReturnRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnReopenBatchPOST: (id, reopenBatchReturnRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('batchReturnReopenBatchPOST', 'id', id);
            const localVarPath = `/api/return/batch/{id}/reopen`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(reopenBatchReturnRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {BatchReturnSearchRequest} [batchReturnSearchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnSearchBatchReturnsPOST: (batchReturnSearchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/return/batch/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(batchReturnSearchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} sourceReturnId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnUnmarkPackageMissingDELETE: (id, sourceReturnId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('batchReturnUnmarkPackageMissingDELETE', 'id', id);
            // verify required parameter 'sourceReturnId' is not null or undefined
            assertParamExists('batchReturnUnmarkPackageMissingDELETE', 'sourceReturnId', sourceReturnId);
            const localVarPath = `/api/return/batch/{id}/packages/{sourceReturnId}/missing`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"sourceReturnId"}}`, encodeURIComponent(String(sourceReturnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {UpdateBatchReturnStatusRequest} [updateBatchReturnStatusRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnUpdateBatchReturnStatusPUT: (id, updateBatchReturnStatusRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('batchReturnUpdateBatchReturnStatusPUT', 'id', id);
            const localVarPath = `/api/return/batch/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateBatchReturnStatusRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BatchReturnApi - functional programming interface
 */
export const BatchReturnApiFp = function (configuration) {
    const localVarAxiosParamCreator = BatchReturnApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnCloseRemainingAsMissingPOST(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnCloseRemainingAsMissingPOST(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnCloseRemainingAsMissingPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnCompleteBatchPOST(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnCompleteBatchPOST(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnCompleteBatchPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {CreateBatchReturnRequest} [createBatchReturnRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnCreateBatchReturnPOST(createBatchReturnRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnCreateBatchReturnPOST(createBatchReturnRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnCreateBatchReturnPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} sourceReturnId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnCreateReturnSlipForPackagePOST(id, sourceReturnId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnCreateReturnSlipForPackagePOST(id, sourceReturnId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnCreateReturnSlipForPackagePOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {CreditBatchSlipsRequest} [creditBatchSlipsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnCreditReturnSlipsPOST(id, creditBatchSlipsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnCreditReturnSlipsPOST(id, creditBatchSlipsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnCreditReturnSlipsPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnGetBatchDestinations(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnGetBatchDestinations(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnGetBatchDestinations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnGetBatchReturnById(id, language, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnGetBatchReturnById(id, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnGetBatchReturnById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnGetBatchReturnStatistics(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnGetBatchReturnStatistics(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnGetBatchReturnStatistics']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {BatchReturnStatusType} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnGetBatchReturns(status, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnGetBatchReturns(status, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnGetBatchReturns']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnGetProcessingSummary(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnGetProcessingSummary(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnGetProcessingSummary']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} sourceReturnId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnMarkPackageMissingPOST(id, sourceReturnId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnMarkPackageMissingPOST(id, sourceReturnId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnMarkPackageMissingPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {MoveBatchRowsRequest} [moveBatchRowsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnMoveRowsToBatchPOST(id, moveBatchRowsRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnMoveRowsToBatchPOST(id, moveBatchRowsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnMoveRowsToBatchPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {ProcessBatchReturnRequest} [processBatchReturnRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnProcessReturnsPOST(id, processBatchReturnRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnProcessReturnsPOST(id, processBatchReturnRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnProcessReturnsPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnReceiveBatchReturnPOST(id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnReceiveBatchReturnPOST(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnReceiveBatchReturnPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {ReopenBatchReturnRequest} [reopenBatchReturnRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnReopenBatchPOST(id, reopenBatchReturnRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnReopenBatchPOST(id, reopenBatchReturnRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnReopenBatchPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {BatchReturnSearchRequest} [batchReturnSearchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnSearchBatchReturnsPOST(batchReturnSearchRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnSearchBatchReturnsPOST(batchReturnSearchRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnSearchBatchReturnsPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} sourceReturnId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnUnmarkPackageMissingDELETE(id, sourceReturnId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnUnmarkPackageMissingDELETE(id, sourceReturnId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnUnmarkPackageMissingDELETE']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {UpdateBatchReturnStatusRequest} [updateBatchReturnStatusRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnUpdateBatchReturnStatusPUT(id, updateBatchReturnStatusRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchReturnUpdateBatchReturnStatusPUT(id, updateBatchReturnStatusRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['BatchReturnApi.batchReturnUpdateBatchReturnStatusPUT']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * BatchReturnApi - factory interface
 */
export const BatchReturnApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BatchReturnApiFp(configuration);
    return {
        /**
         *
         * @param {BatchReturnApiBatchReturnCloseRemainingAsMissingPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnCloseRemainingAsMissingPOST(requestParameters, options) {
            return localVarFp.batchReturnCloseRemainingAsMissingPOST(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BatchReturnApiBatchReturnCompleteBatchPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnCompleteBatchPOST(requestParameters, options) {
            return localVarFp.batchReturnCompleteBatchPOST(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BatchReturnApiBatchReturnCreateBatchReturnPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnCreateBatchReturnPOST(requestParameters = {}, options) {
            return localVarFp.batchReturnCreateBatchReturnPOST(requestParameters.createBatchReturnRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BatchReturnApiBatchReturnCreateReturnSlipForPackagePOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnCreateReturnSlipForPackagePOST(requestParameters, options) {
            return localVarFp.batchReturnCreateReturnSlipForPackagePOST(requestParameters.id, requestParameters.sourceReturnId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BatchReturnApiBatchReturnCreditReturnSlipsPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnCreditReturnSlipsPOST(requestParameters, options) {
            return localVarFp.batchReturnCreditReturnSlipsPOST(requestParameters.id, requestParameters.creditBatchSlipsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnGetBatchDestinations(options) {
            return localVarFp.batchReturnGetBatchDestinations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BatchReturnApiBatchReturnGetBatchReturnByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnGetBatchReturnById(requestParameters, options) {
            return localVarFp.batchReturnGetBatchReturnById(requestParameters.id, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnGetBatchReturnStatistics(options) {
            return localVarFp.batchReturnGetBatchReturnStatistics(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BatchReturnApiBatchReturnGetBatchReturnsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnGetBatchReturns(requestParameters = {}, options) {
            return localVarFp.batchReturnGetBatchReturns(requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BatchReturnApiBatchReturnGetProcessingSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnGetProcessingSummary(requestParameters, options) {
            return localVarFp.batchReturnGetProcessingSummary(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BatchReturnApiBatchReturnMarkPackageMissingPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnMarkPackageMissingPOST(requestParameters, options) {
            return localVarFp.batchReturnMarkPackageMissingPOST(requestParameters.id, requestParameters.sourceReturnId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BatchReturnApiBatchReturnMoveRowsToBatchPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnMoveRowsToBatchPOST(requestParameters, options) {
            return localVarFp.batchReturnMoveRowsToBatchPOST(requestParameters.id, requestParameters.moveBatchRowsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BatchReturnApiBatchReturnProcessReturnsPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnProcessReturnsPOST(requestParameters, options) {
            return localVarFp.batchReturnProcessReturnsPOST(requestParameters.id, requestParameters.processBatchReturnRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BatchReturnApiBatchReturnReceiveBatchReturnPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnReceiveBatchReturnPOST(requestParameters, options) {
            return localVarFp.batchReturnReceiveBatchReturnPOST(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BatchReturnApiBatchReturnReopenBatchPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnReopenBatchPOST(requestParameters, options) {
            return localVarFp.batchReturnReopenBatchPOST(requestParameters.id, requestParameters.reopenBatchReturnRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BatchReturnApiBatchReturnSearchBatchReturnsPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnSearchBatchReturnsPOST(requestParameters = {}, options) {
            return localVarFp.batchReturnSearchBatchReturnsPOST(requestParameters.batchReturnSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BatchReturnApiBatchReturnUnmarkPackageMissingDELETERequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnUnmarkPackageMissingDELETE(requestParameters, options) {
            return localVarFp.batchReturnUnmarkPackageMissingDELETE(requestParameters.id, requestParameters.sourceReturnId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BatchReturnApiBatchReturnUpdateBatchReturnStatusPUTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchReturnUpdateBatchReturnStatusPUT(requestParameters, options) {
            return localVarFp.batchReturnUpdateBatchReturnStatusPUT(requestParameters.id, requestParameters.updateBatchReturnStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BatchReturnApi - object-oriented interface
 */
export class BatchReturnApi extends BaseAPI {
    /**
     *
     * @param {BatchReturnApiBatchReturnCloseRemainingAsMissingPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnCloseRemainingAsMissingPOST(requestParameters, options) {
        return BatchReturnApiFp(this.configuration).batchReturnCloseRemainingAsMissingPOST(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BatchReturnApiBatchReturnCompleteBatchPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnCompleteBatchPOST(requestParameters, options) {
        return BatchReturnApiFp(this.configuration).batchReturnCompleteBatchPOST(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BatchReturnApiBatchReturnCreateBatchReturnPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnCreateBatchReturnPOST(requestParameters = {}, options) {
        return BatchReturnApiFp(this.configuration).batchReturnCreateBatchReturnPOST(requestParameters.createBatchReturnRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BatchReturnApiBatchReturnCreateReturnSlipForPackagePOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnCreateReturnSlipForPackagePOST(requestParameters, options) {
        return BatchReturnApiFp(this.configuration).batchReturnCreateReturnSlipForPackagePOST(requestParameters.id, requestParameters.sourceReturnId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BatchReturnApiBatchReturnCreditReturnSlipsPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnCreditReturnSlipsPOST(requestParameters, options) {
        return BatchReturnApiFp(this.configuration).batchReturnCreditReturnSlipsPOST(requestParameters.id, requestParameters.creditBatchSlipsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnGetBatchDestinations(options) {
        return BatchReturnApiFp(this.configuration).batchReturnGetBatchDestinations(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BatchReturnApiBatchReturnGetBatchReturnByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnGetBatchReturnById(requestParameters, options) {
        return BatchReturnApiFp(this.configuration).batchReturnGetBatchReturnById(requestParameters.id, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnGetBatchReturnStatistics(options) {
        return BatchReturnApiFp(this.configuration).batchReturnGetBatchReturnStatistics(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BatchReturnApiBatchReturnGetBatchReturnsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnGetBatchReturns(requestParameters = {}, options) {
        return BatchReturnApiFp(this.configuration).batchReturnGetBatchReturns(requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BatchReturnApiBatchReturnGetProcessingSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnGetProcessingSummary(requestParameters, options) {
        return BatchReturnApiFp(this.configuration).batchReturnGetProcessingSummary(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BatchReturnApiBatchReturnMarkPackageMissingPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnMarkPackageMissingPOST(requestParameters, options) {
        return BatchReturnApiFp(this.configuration).batchReturnMarkPackageMissingPOST(requestParameters.id, requestParameters.sourceReturnId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BatchReturnApiBatchReturnMoveRowsToBatchPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnMoveRowsToBatchPOST(requestParameters, options) {
        return BatchReturnApiFp(this.configuration).batchReturnMoveRowsToBatchPOST(requestParameters.id, requestParameters.moveBatchRowsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BatchReturnApiBatchReturnProcessReturnsPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnProcessReturnsPOST(requestParameters, options) {
        return BatchReturnApiFp(this.configuration).batchReturnProcessReturnsPOST(requestParameters.id, requestParameters.processBatchReturnRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BatchReturnApiBatchReturnReceiveBatchReturnPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnReceiveBatchReturnPOST(requestParameters, options) {
        return BatchReturnApiFp(this.configuration).batchReturnReceiveBatchReturnPOST(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BatchReturnApiBatchReturnReopenBatchPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnReopenBatchPOST(requestParameters, options) {
        return BatchReturnApiFp(this.configuration).batchReturnReopenBatchPOST(requestParameters.id, requestParameters.reopenBatchReturnRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BatchReturnApiBatchReturnSearchBatchReturnsPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnSearchBatchReturnsPOST(requestParameters = {}, options) {
        return BatchReturnApiFp(this.configuration).batchReturnSearchBatchReturnsPOST(requestParameters.batchReturnSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BatchReturnApiBatchReturnUnmarkPackageMissingDELETERequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnUnmarkPackageMissingDELETE(requestParameters, options) {
        return BatchReturnApiFp(this.configuration).batchReturnUnmarkPackageMissingDELETE(requestParameters.id, requestParameters.sourceReturnId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BatchReturnApiBatchReturnUpdateBatchReturnStatusPUTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    batchReturnUpdateBatchReturnStatusPUT(requestParameters, options) {
        return BatchReturnApiFp(this.configuration).batchReturnUpdateBatchReturnStatusPUT(requestParameters.id, requestParameters.updateBatchReturnStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ConfigApi - axios parameter creator
 */
export const ConfigApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configGetConfig: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ConfigApi - functional programming interface
 */
export const ConfigApiFp = function (configuration) {
    const localVarAxiosParamCreator = ConfigApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configGetConfig(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configGetConfig(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigApi.configGetConfig']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * ConfigApi - factory interface
 */
export const ConfigApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ConfigApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configGetConfig(options) {
            return localVarFp.configGetConfig(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConfigApi - object-oriented interface
 */
export class ConfigApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configGetConfig(options) {
        return ConfigApiFp(this.configuration).configGetConfig(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ConfigurationApi - axios parameter creator
 */
export const ConfigurationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationGetAppDisplaySettings: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/config/display-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationGetCompanies: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/config/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationGetReturnCenterSettings: (language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/config/return-center-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ConfigurationApi - functional programming interface
 */
export const ConfigurationApiFp = function (configuration) {
    const localVarAxiosParamCreator = ConfigurationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationGetAppDisplaySettings(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configurationGetAppDisplaySettings(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigurationApi.configurationGetAppDisplaySettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationGetCompanies(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configurationGetCompanies(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigurationApi.configurationGetCompanies']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationGetReturnCenterSettings(language, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configurationGetReturnCenterSettings(language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ConfigurationApi.configurationGetReturnCenterSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * ConfigurationApi - factory interface
 */
export const ConfigurationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ConfigurationApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationGetAppDisplaySettings(options) {
            return localVarFp.configurationGetAppDisplaySettings(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationGetCompanies(options) {
            return localVarFp.configurationGetCompanies(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ConfigurationApiConfigurationGetReturnCenterSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configurationGetReturnCenterSettings(requestParameters = {}, options) {
            return localVarFp.configurationGetReturnCenterSettings(requestParameters.language, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConfigurationApi - object-oriented interface
 */
export class ConfigurationApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configurationGetAppDisplaySettings(options) {
        return ConfigurationApiFp(this.configuration).configurationGetAppDisplaySettings(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configurationGetCompanies(options) {
        return ConfigurationApiFp(this.configuration).configurationGetCompanies(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ConfigurationApiConfigurationGetReturnCenterSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configurationGetReturnCenterSettings(requestParameters = {}, options) {
        return ConfigurationApiFp(this.configuration).configurationGetReturnCenterSettings(requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DecisionCodeApi - axios parameter creator
 */
export const DecisionCodeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {DetermineDecisionCodesRequest} [determineDecisionCodesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decisionCodeDetermineDecisionCodesPOST: (determineDecisionCodesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/decision-codes/determine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(determineDecisionCodesRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} customerCode
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decisionCodeGetDecisionCodesForCustomer: (customerCode, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerCode' is not null or undefined
            assertParamExists('decisionCodeGetDecisionCodesForCustomer', 'customerCode', customerCode);
            const localVarPath = `/api/decision-codes/customer/{customerCode}`
                .replace(`{${"customerCode"}}`, encodeURIComponent(String(customerCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DecisionCodeApi - functional programming interface
 */
export const DecisionCodeApiFp = function (configuration) {
    const localVarAxiosParamCreator = DecisionCodeApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {DetermineDecisionCodesRequest} [determineDecisionCodesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decisionCodeDetermineDecisionCodesPOST(determineDecisionCodesRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.decisionCodeDetermineDecisionCodesPOST(determineDecisionCodesRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DecisionCodeApi.decisionCodeDetermineDecisionCodesPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} customerCode
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decisionCodeGetDecisionCodesForCustomer(customerCode, language, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.decisionCodeGetDecisionCodesForCustomer(customerCode, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DecisionCodeApi.decisionCodeGetDecisionCodesForCustomer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * DecisionCodeApi - factory interface
 */
export const DecisionCodeApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DecisionCodeApiFp(configuration);
    return {
        /**
         *
         * @param {DecisionCodeApiDecisionCodeDetermineDecisionCodesPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decisionCodeDetermineDecisionCodesPOST(requestParameters = {}, options) {
            return localVarFp.decisionCodeDetermineDecisionCodesPOST(requestParameters.determineDecisionCodesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DecisionCodeApiDecisionCodeGetDecisionCodesForCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decisionCodeGetDecisionCodesForCustomer(requestParameters, options) {
            return localVarFp.decisionCodeGetDecisionCodesForCustomer(requestParameters.customerCode, requestParameters.language, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DecisionCodeApi - object-oriented interface
 */
export class DecisionCodeApi extends BaseAPI {
    /**
     *
     * @param {DecisionCodeApiDecisionCodeDetermineDecisionCodesPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    decisionCodeDetermineDecisionCodesPOST(requestParameters = {}, options) {
        return DecisionCodeApiFp(this.configuration).decisionCodeDetermineDecisionCodesPOST(requestParameters.determineDecisionCodesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DecisionCodeApiDecisionCodeGetDecisionCodesForCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    decisionCodeGetDecisionCodesForCustomer(requestParameters, options) {
        return DecisionCodeApiFp(this.configuration).decisionCodeGetDecisionCodesForCustomer(requestParameters.customerCode, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrderApi - axios parameter creator
 */
export const OrderApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} orderNumber
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetCreditNote: (orderNumber, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderNumber' is not null or undefined
            assertParamExists('orderGetCreditNote', 'orderNumber', orderNumber);
            const localVarPath = `/api/order/creditnote/{orderNumber}`
                .replace(`{${"orderNumber"}}`, encodeURIComponent(String(orderNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} orderId
         * @param {string} [customerCode]
         * @param {string} [language]
         * @param {string} [arrivalDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetOrder: (orderId, customerCode, language, arrivalDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('orderGetOrder', 'orderId', orderId);
            const localVarPath = `/api/order/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (customerCode !== undefined) {
                localVarQueryParameter['customerCode'] = customerCode;
            }
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            if (arrivalDate !== undefined) {
                localVarQueryParameter['arrivalDate'] = (arrivalDate instanceof Date) ?
                    arrivalDate.toISOString() :
                    arrivalDate;
            }
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} barcode
         * @param {string} [customerCode]
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetOrderByBarcode: (barcode, customerCode, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'barcode' is not null or undefined
            assertParamExists('orderGetOrderByBarcode', 'barcode', barcode);
            const localVarPath = `/api/order/barcode/{barcode}`
                .replace(`{${"barcode"}}`, encodeURIComponent(String(barcode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (customerCode !== undefined) {
                localVarQueryParameter['customerCode'] = customerCode;
            }
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetOrderDeliveryInfoPOST: (requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/order/delivery-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [search]
         * @param {string} [customerCode]
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [size]
         * @param {number} [afterOrderNumber]
         * @param {boolean} [searchArticles]
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetOrders: (search, customerCode, from, to, size, afterOrderNumber, searchArticles, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (search !== undefined) {
                localVarQueryParameter['Search'] = search;
            }
            if (customerCode !== undefined) {
                localVarQueryParameter['CustomerCode'] = customerCode;
            }
            if (from !== undefined) {
                localVarQueryParameter['From'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['To'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            if (size !== undefined) {
                localVarQueryParameter['Size'] = size;
            }
            if (afterOrderNumber !== undefined) {
                localVarQueryParameter['AfterOrderNumber'] = afterOrderNumber;
            }
            if (searchArticles !== undefined) {
                localVarQueryParameter['SearchArticles'] = searchArticles;
            }
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [search]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderSearchCustomers: (search, pageSize, pageNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/order/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OrderApi - functional programming interface
 */
export const OrderApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrderApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} orderNumber
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetCreditNote(orderNumber, language, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderGetCreditNote(orderNumber, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OrderApi.orderGetCreditNote']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} orderId
         * @param {string} [customerCode]
         * @param {string} [language]
         * @param {string} [arrivalDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetOrder(orderId, customerCode, language, arrivalDate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderGetOrder(orderId, customerCode, language, arrivalDate, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OrderApi.orderGetOrder']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} barcode
         * @param {string} [customerCode]
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetOrderByBarcode(barcode, customerCode, language, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderGetOrderByBarcode(barcode, customerCode, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OrderApi.orderGetOrderByBarcode']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetOrderDeliveryInfoPOST(requestBody, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderGetOrderDeliveryInfoPOST(requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OrderApi.orderGetOrderDeliveryInfoPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [search]
         * @param {string} [customerCode]
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [size]
         * @param {number} [afterOrderNumber]
         * @param {boolean} [searchArticles]
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetOrders(search, customerCode, from, to, size, afterOrderNumber, searchArticles, language, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderGetOrders(search, customerCode, from, to, size, afterOrderNumber, searchArticles, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OrderApi.orderGetOrders']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [search]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderSearchCustomers(search, pageSize, pageNumber, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderSearchCustomers(search, pageSize, pageNumber, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OrderApi.orderSearchCustomers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * OrderApi - factory interface
 */
export const OrderApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrderApiFp(configuration);
    return {
        /**
         *
         * @param {OrderApiOrderGetCreditNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetCreditNote(requestParameters, options) {
            return localVarFp.orderGetCreditNote(requestParameters.orderNumber, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderApiOrderGetOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetOrder(requestParameters, options) {
            return localVarFp.orderGetOrder(requestParameters.orderId, requestParameters.customerCode, requestParameters.language, requestParameters.arrivalDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderApiOrderGetOrderByBarcodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetOrderByBarcode(requestParameters, options) {
            return localVarFp.orderGetOrderByBarcode(requestParameters.barcode, requestParameters.customerCode, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderApiOrderGetOrderDeliveryInfoPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetOrderDeliveryInfoPOST(requestParameters = {}, options) {
            return localVarFp.orderGetOrderDeliveryInfoPOST(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderApiOrderGetOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetOrders(requestParameters = {}, options) {
            return localVarFp.orderGetOrders(requestParameters.search, requestParameters.customerCode, requestParameters.from, requestParameters.to, requestParameters.size, requestParameters.afterOrderNumber, requestParameters.searchArticles, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderApiOrderSearchCustomersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderSearchCustomers(requestParameters = {}, options) {
            return localVarFp.orderSearchCustomers(requestParameters.search, requestParameters.pageSize, requestParameters.pageNumber, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrderApi - object-oriented interface
 */
export class OrderApi extends BaseAPI {
    /**
     *
     * @param {OrderApiOrderGetCreditNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderGetCreditNote(requestParameters, options) {
        return OrderApiFp(this.configuration).orderGetCreditNote(requestParameters.orderNumber, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderApiOrderGetOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderGetOrder(requestParameters, options) {
        return OrderApiFp(this.configuration).orderGetOrder(requestParameters.orderId, requestParameters.customerCode, requestParameters.language, requestParameters.arrivalDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderApiOrderGetOrderByBarcodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderGetOrderByBarcode(requestParameters, options) {
        return OrderApiFp(this.configuration).orderGetOrderByBarcode(requestParameters.barcode, requestParameters.customerCode, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderApiOrderGetOrderDeliveryInfoPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderGetOrderDeliveryInfoPOST(requestParameters = {}, options) {
        return OrderApiFp(this.configuration).orderGetOrderDeliveryInfoPOST(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderApiOrderGetOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderGetOrders(requestParameters = {}, options) {
        return OrderApiFp(this.configuration).orderGetOrders(requestParameters.search, requestParameters.customerCode, requestParameters.from, requestParameters.to, requestParameters.size, requestParameters.afterOrderNumber, requestParameters.searchArticles, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderApiOrderSearchCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderSearchCustomers(requestParameters = {}, options) {
        return OrderApiFp(this.configuration).orderSearchCustomers(requestParameters.search, requestParameters.pageSize, requestParameters.pageNumber, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ReturnApi - axios parameter creator
 */
export const ReturnApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} returnId
         * @param {AddReturnLogRequest} [addReturnLogRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnAddCommentToReturnLogPOST: (returnId, addReturnLogRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('returnAddCommentToReturnLogPOST', 'returnId', returnId);
            const localVarPath = `/api/return/{returnId}/logs`
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addReturnLogRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} returnId
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnCreateIntercompanyCreditsPOST: (returnId, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('returnCreateIntercompanyCreditsPOST', 'returnId', returnId);
            const localVarPath = `/api/return/{returnId}/intercompany/credit`
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [language]
         * @param {ReturnSlip} [returnSlip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnCreateReturnCreditPOST: (language, returnSlip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/return/createreturncredit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(returnSlip, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [language]
         * @param {ReturnSlip} [returnSlip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnCreateReturnPOST: (language, returnSlip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/return/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(returnSlip, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} returnId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnDeleteReturnPOST: (returnId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('returnDeleteReturnPOST', 'returnId', returnId);
            const localVarPath = `/api/return/delete/{returnId}`
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [language]
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetAllOrderLinesPOST: (language, requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/return/orderlines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetB2CAttentionCount: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/return/b2c/attention-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} returnId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetB2CState: (returnId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('returnGetB2CState', 'returnId', returnId);
            const localVarPath = `/api/return/{returnId}/b2c`
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} returnId
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetIntercompanyPreview: (returnId, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('returnGetIntercompanyPreview', 'returnId', returnId);
            const localVarPath = `/api/return/{returnId}/intercompany/preview`
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} returnId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetIntercompanyReturns: (returnId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('returnGetIntercompanyReturns', 'returnId', returnId);
            const localVarPath = `/api/return/{returnId}/intercompany`
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} returnId
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetReturn: (returnId, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('returnGetReturn', 'returnId', returnId);
            const localVarPath = `/api/return/{returnId}`
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} returnId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetReturnLogsByReturnId: (returnId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('returnGetReturnLogsByReturnId', 'returnId', returnId);
            const localVarPath = `/api/return/{returnId}/logs`
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetReturnStatisticsForCurrentCompany: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/return/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [sku]
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnLookupMisPickSku: (sku, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/return/mispick-sku`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sku !== undefined) {
                localVarQueryParameter['sku'] = sku;
            }
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} returnId
         * @param {string} [language]
         * @param {B2CHandledRequest} [b2CHandledRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnMarkB2CHandledPOST: (returnId, language, b2CHandledRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('returnMarkB2CHandledPOST', 'returnId', returnId);
            const localVarPath = `/api/return/{returnId}/b2c/handled`
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(b2CHandledRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} returnId
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnReopenBatchSlipPOST: (returnId, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('returnReopenBatchSlipPOST', 'returnId', returnId);
            const localVarPath = `/api/return/{returnId}/batch/reopen`
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} returnId
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnResendB2CPOST: (returnId, language, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'returnId' is not null or undefined
            assertParamExists('returnResendB2CPOST', 'returnId', returnId);
            const localVarPath = `/api/return/{returnId}/b2c/resend`
                .replace(`{${"returnId"}}`, encodeURIComponent(String(returnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {IntercompanyDecisionCodeRequest} [intercompanyDecisionCodeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnResolveIntercompanyDecisionCodesPOST: (intercompanyDecisionCodeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/return/intercompany/decision-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(intercompanyDecisionCodeRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [language]
         * @param {ReturnOverviewRequest} [returnOverviewRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnSearchReturnsPOST: (language, returnOverviewRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/return/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(returnOverviewRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} logId
         * @param {boolean} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnUpdateReturnLogPinnedPATCH: (logId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'logId' is not null or undefined
            assertParamExists('returnUpdateReturnLogPinnedPATCH', 'logId', logId);
            const localVarPath = `/api/return/logs/{logId}/pinned`
                .replace(`{${"logId"}}`, encodeURIComponent(String(logId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [language]
         * @param {ReturnSlip} [returnSlip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnUpdateReturnPOST: (language, returnSlip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/return/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(returnSlip, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ReturnApi - functional programming interface
 */
export const ReturnApiFp = function (configuration) {
    const localVarAxiosParamCreator = ReturnApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} returnId
         * @param {AddReturnLogRequest} [addReturnLogRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnAddCommentToReturnLogPOST(returnId, addReturnLogRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnAddCommentToReturnLogPOST(returnId, addReturnLogRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnAddCommentToReturnLogPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} returnId
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnCreateIntercompanyCreditsPOST(returnId, language, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnCreateIntercompanyCreditsPOST(returnId, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnCreateIntercompanyCreditsPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [language]
         * @param {ReturnSlip} [returnSlip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnCreateReturnCreditPOST(language, returnSlip, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnCreateReturnCreditPOST(language, returnSlip, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnCreateReturnCreditPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [language]
         * @param {ReturnSlip} [returnSlip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnCreateReturnPOST(language, returnSlip, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnCreateReturnPOST(language, returnSlip, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnCreateReturnPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} returnId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnDeleteReturnPOST(returnId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnDeleteReturnPOST(returnId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnDeleteReturnPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [language]
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetAllOrderLinesPOST(language, requestBody, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnGetAllOrderLinesPOST(language, requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnGetAllOrderLinesPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetB2CAttentionCount(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnGetB2CAttentionCount(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnGetB2CAttentionCount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} returnId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetB2CState(returnId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnGetB2CState(returnId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnGetB2CState']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} returnId
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetIntercompanyPreview(returnId, language, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnGetIntercompanyPreview(returnId, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnGetIntercompanyPreview']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} returnId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetIntercompanyReturns(returnId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnGetIntercompanyReturns(returnId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnGetIntercompanyReturns']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} returnId
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetReturn(returnId, language, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnGetReturn(returnId, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnGetReturn']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} returnId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetReturnLogsByReturnId(returnId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnGetReturnLogsByReturnId(returnId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnGetReturnLogsByReturnId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetReturnStatisticsForCurrentCompany(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnGetReturnStatisticsForCurrentCompany(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnGetReturnStatisticsForCurrentCompany']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [sku]
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnLookupMisPickSku(sku, language, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnLookupMisPickSku(sku, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnLookupMisPickSku']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} returnId
         * @param {string} [language]
         * @param {B2CHandledRequest} [b2CHandledRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnMarkB2CHandledPOST(returnId, language, b2CHandledRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnMarkB2CHandledPOST(returnId, language, b2CHandledRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnMarkB2CHandledPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} returnId
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnReopenBatchSlipPOST(returnId, language, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnReopenBatchSlipPOST(returnId, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnReopenBatchSlipPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} returnId
         * @param {string} [language]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnResendB2CPOST(returnId, language, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnResendB2CPOST(returnId, language, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnResendB2CPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {IntercompanyDecisionCodeRequest} [intercompanyDecisionCodeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnResolveIntercompanyDecisionCodesPOST(intercompanyDecisionCodeRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnResolveIntercompanyDecisionCodesPOST(intercompanyDecisionCodeRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnResolveIntercompanyDecisionCodesPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [language]
         * @param {ReturnOverviewRequest} [returnOverviewRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnSearchReturnsPOST(language, returnOverviewRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnSearchReturnsPOST(language, returnOverviewRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnSearchReturnsPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} logId
         * @param {boolean} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnUpdateReturnLogPinnedPATCH(logId, body, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnUpdateReturnLogPinnedPATCH(logId, body, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnUpdateReturnLogPinnedPATCH']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [language]
         * @param {ReturnSlip} [returnSlip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnUpdateReturnPOST(language, returnSlip, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.returnUpdateReturnPOST(language, returnSlip, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ReturnApi.returnUpdateReturnPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * ReturnApi - factory interface
 */
export const ReturnApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ReturnApiFp(configuration);
    return {
        /**
         *
         * @param {ReturnApiReturnAddCommentToReturnLogPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnAddCommentToReturnLogPOST(requestParameters, options) {
            return localVarFp.returnAddCommentToReturnLogPOST(requestParameters.returnId, requestParameters.addReturnLogRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnCreateIntercompanyCreditsPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnCreateIntercompanyCreditsPOST(requestParameters, options) {
            return localVarFp.returnCreateIntercompanyCreditsPOST(requestParameters.returnId, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnCreateReturnCreditPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnCreateReturnCreditPOST(requestParameters = {}, options) {
            return localVarFp.returnCreateReturnCreditPOST(requestParameters.language, requestParameters.returnSlip, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnCreateReturnPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnCreateReturnPOST(requestParameters = {}, options) {
            return localVarFp.returnCreateReturnPOST(requestParameters.language, requestParameters.returnSlip, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnDeleteReturnPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnDeleteReturnPOST(requestParameters, options) {
            return localVarFp.returnDeleteReturnPOST(requestParameters.returnId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnGetAllOrderLinesPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetAllOrderLinesPOST(requestParameters = {}, options) {
            return localVarFp.returnGetAllOrderLinesPOST(requestParameters.language, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetB2CAttentionCount(options) {
            return localVarFp.returnGetB2CAttentionCount(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnGetB2CStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetB2CState(requestParameters, options) {
            return localVarFp.returnGetB2CState(requestParameters.returnId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnGetIntercompanyPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetIntercompanyPreview(requestParameters, options) {
            return localVarFp.returnGetIntercompanyPreview(requestParameters.returnId, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnGetIntercompanyReturnsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetIntercompanyReturns(requestParameters, options) {
            return localVarFp.returnGetIntercompanyReturns(requestParameters.returnId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnGetReturnRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetReturn(requestParameters, options) {
            return localVarFp.returnGetReturn(requestParameters.returnId, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnGetReturnLogsByReturnIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetReturnLogsByReturnId(requestParameters, options) {
            return localVarFp.returnGetReturnLogsByReturnId(requestParameters.returnId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnGetReturnStatisticsForCurrentCompany(options) {
            return localVarFp.returnGetReturnStatisticsForCurrentCompany(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnLookupMisPickSkuRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnLookupMisPickSku(requestParameters = {}, options) {
            return localVarFp.returnLookupMisPickSku(requestParameters.sku, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnMarkB2CHandledPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnMarkB2CHandledPOST(requestParameters, options) {
            return localVarFp.returnMarkB2CHandledPOST(requestParameters.returnId, requestParameters.language, requestParameters.b2CHandledRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnReopenBatchSlipPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnReopenBatchSlipPOST(requestParameters, options) {
            return localVarFp.returnReopenBatchSlipPOST(requestParameters.returnId, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnResendB2CPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnResendB2CPOST(requestParameters, options) {
            return localVarFp.returnResendB2CPOST(requestParameters.returnId, requestParameters.language, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnResolveIntercompanyDecisionCodesPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnResolveIntercompanyDecisionCodesPOST(requestParameters = {}, options) {
            return localVarFp.returnResolveIntercompanyDecisionCodesPOST(requestParameters.intercompanyDecisionCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnSearchReturnsPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnSearchReturnsPOST(requestParameters = {}, options) {
            return localVarFp.returnSearchReturnsPOST(requestParameters.language, requestParameters.returnOverviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnUpdateReturnLogPinnedPATCHRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnUpdateReturnLogPinnedPATCH(requestParameters, options) {
            return localVarFp.returnUpdateReturnLogPinnedPATCH(requestParameters.logId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReturnApiReturnUpdateReturnPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnUpdateReturnPOST(requestParameters = {}, options) {
            return localVarFp.returnUpdateReturnPOST(requestParameters.language, requestParameters.returnSlip, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ReturnApi - object-oriented interface
 */
export class ReturnApi extends BaseAPI {
    /**
     *
     * @param {ReturnApiReturnAddCommentToReturnLogPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnAddCommentToReturnLogPOST(requestParameters, options) {
        return ReturnApiFp(this.configuration).returnAddCommentToReturnLogPOST(requestParameters.returnId, requestParameters.addReturnLogRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnCreateIntercompanyCreditsPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnCreateIntercompanyCreditsPOST(requestParameters, options) {
        return ReturnApiFp(this.configuration).returnCreateIntercompanyCreditsPOST(requestParameters.returnId, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnCreateReturnCreditPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnCreateReturnCreditPOST(requestParameters = {}, options) {
        return ReturnApiFp(this.configuration).returnCreateReturnCreditPOST(requestParameters.language, requestParameters.returnSlip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnCreateReturnPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnCreateReturnPOST(requestParameters = {}, options) {
        return ReturnApiFp(this.configuration).returnCreateReturnPOST(requestParameters.language, requestParameters.returnSlip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnDeleteReturnPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnDeleteReturnPOST(requestParameters, options) {
        return ReturnApiFp(this.configuration).returnDeleteReturnPOST(requestParameters.returnId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnGetAllOrderLinesPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnGetAllOrderLinesPOST(requestParameters = {}, options) {
        return ReturnApiFp(this.configuration).returnGetAllOrderLinesPOST(requestParameters.language, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnGetB2CAttentionCount(options) {
        return ReturnApiFp(this.configuration).returnGetB2CAttentionCount(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnGetB2CStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnGetB2CState(requestParameters, options) {
        return ReturnApiFp(this.configuration).returnGetB2CState(requestParameters.returnId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnGetIntercompanyPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnGetIntercompanyPreview(requestParameters, options) {
        return ReturnApiFp(this.configuration).returnGetIntercompanyPreview(requestParameters.returnId, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnGetIntercompanyReturnsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnGetIntercompanyReturns(requestParameters, options) {
        return ReturnApiFp(this.configuration).returnGetIntercompanyReturns(requestParameters.returnId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnGetReturnRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnGetReturn(requestParameters, options) {
        return ReturnApiFp(this.configuration).returnGetReturn(requestParameters.returnId, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnGetReturnLogsByReturnIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnGetReturnLogsByReturnId(requestParameters, options) {
        return ReturnApiFp(this.configuration).returnGetReturnLogsByReturnId(requestParameters.returnId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnGetReturnStatisticsForCurrentCompany(options) {
        return ReturnApiFp(this.configuration).returnGetReturnStatisticsForCurrentCompany(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnLookupMisPickSkuRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnLookupMisPickSku(requestParameters = {}, options) {
        return ReturnApiFp(this.configuration).returnLookupMisPickSku(requestParameters.sku, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnMarkB2CHandledPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnMarkB2CHandledPOST(requestParameters, options) {
        return ReturnApiFp(this.configuration).returnMarkB2CHandledPOST(requestParameters.returnId, requestParameters.language, requestParameters.b2CHandledRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnReopenBatchSlipPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnReopenBatchSlipPOST(requestParameters, options) {
        return ReturnApiFp(this.configuration).returnReopenBatchSlipPOST(requestParameters.returnId, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnResendB2CPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnResendB2CPOST(requestParameters, options) {
        return ReturnApiFp(this.configuration).returnResendB2CPOST(requestParameters.returnId, requestParameters.language, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnResolveIntercompanyDecisionCodesPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnResolveIntercompanyDecisionCodesPOST(requestParameters = {}, options) {
        return ReturnApiFp(this.configuration).returnResolveIntercompanyDecisionCodesPOST(requestParameters.intercompanyDecisionCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnSearchReturnsPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnSearchReturnsPOST(requestParameters = {}, options) {
        return ReturnApiFp(this.configuration).returnSearchReturnsPOST(requestParameters.language, requestParameters.returnOverviewRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnUpdateReturnLogPinnedPATCHRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnUpdateReturnLogPinnedPATCH(requestParameters, options) {
        return ReturnApiFp(this.configuration).returnUpdateReturnLogPinnedPATCH(requestParameters.logId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReturnApiReturnUpdateReturnPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    returnUpdateReturnPOST(requestParameters = {}, options) {
        return ReturnApiFp(this.configuration).returnUpdateReturnPOST(requestParameters.language, requestParameters.returnSlip, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SkuLocationApi - axios parameter creator
 */
export const SkuLocationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuLocationGetSkuLocations: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/sku-location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuLocationGetSkuLocationsBySkusPOST: (requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/sku-location/by-skus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuLocationGetTemplate: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/sku-location/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {File} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuLocationUploadSkuLocationsPOST: (file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/sku-location/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SkuLocationApi - functional programming interface
 */
export const SkuLocationApiFp = function (configuration) {
    const localVarAxiosParamCreator = SkuLocationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuLocationGetSkuLocations(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.skuLocationGetSkuLocations(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SkuLocationApi.skuLocationGetSkuLocations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuLocationGetSkuLocationsBySkusPOST(requestBody, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.skuLocationGetSkuLocationsBySkusPOST(requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SkuLocationApi.skuLocationGetSkuLocationsBySkusPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuLocationGetTemplate(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.skuLocationGetTemplate(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SkuLocationApi.skuLocationGetTemplate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {File} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuLocationUploadSkuLocationsPOST(file, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.skuLocationUploadSkuLocationsPOST(file, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['SkuLocationApi.skuLocationUploadSkuLocationsPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * SkuLocationApi - factory interface
 */
export const SkuLocationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SkuLocationApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuLocationGetSkuLocations(options) {
            return localVarFp.skuLocationGetSkuLocations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SkuLocationApiSkuLocationGetSkuLocationsBySkusPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuLocationGetSkuLocationsBySkusPOST(requestParameters = {}, options) {
            return localVarFp.skuLocationGetSkuLocationsBySkusPOST(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuLocationGetTemplate(options) {
            return localVarFp.skuLocationGetTemplate(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SkuLocationApiSkuLocationUploadSkuLocationsPOSTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuLocationUploadSkuLocationsPOST(requestParameters = {}, options) {
            return localVarFp.skuLocationUploadSkuLocationsPOST(requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SkuLocationApi - object-oriented interface
 */
export class SkuLocationApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    skuLocationGetSkuLocations(options) {
        return SkuLocationApiFp(this.configuration).skuLocationGetSkuLocations(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SkuLocationApiSkuLocationGetSkuLocationsBySkusPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    skuLocationGetSkuLocationsBySkusPOST(requestParameters = {}, options) {
        return SkuLocationApiFp(this.configuration).skuLocationGetSkuLocationsBySkusPOST(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    skuLocationGetTemplate(options) {
        return SkuLocationApiFp(this.configuration).skuLocationGetTemplate(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SkuLocationApiSkuLocationUploadSkuLocationsPOSTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    skuLocationUploadSkuLocationsPOST(requestParameters = {}, options) {
        return SkuLocationApiFp(this.configuration).skuLocationUploadSkuLocationsPOST(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}
